import { AppEffects } from './app.effects'
import * as fromMenu from '../../shared/navbar/menu'
import * as fromSignal from '../../shared/signalR'
import * as fromAuth from '../../shared/auth'
import * as fromTeam from '../../shared/team'

export * from './app.effects'

export const effects: any[] = [
  AppEffects,
  ...fromMenu.effects,
  ...fromSignal.effects,
  ...fromAuth.effects,
  ...fromTeam.effects,
]



// WEBPACK FOOTER //
// ./src/app/store/effects/index.ts